export const intcmpMap = {
    leagues: {
        dataAttribute: 'intcmp',
        team: 'skysport_sportsdata_squadre_news-squadra',
        accordion: 'skysport_sportsdata_squadre_competizione',
    },
    competitionCalendarAndResults: {
        intcmp: 'skysport_sportsdata_calendario-risultati_null'
    },
    teamCalendarAndResults: {
        intcmp: 'skysport_sportsdata_calendario-risultati_null'
    },
};  